<template>
  <div>
    <el-dialog :title="$t('batchPayConfirm.title')" :visible.sync="visible" width="600px" :before-close="handleClose">
      <el-form label-width="140px">
        <el-form-item label="应收金额：">
          <span>{{ receivableAmount }} {{ $t('batchPayConfirm.yuan') }}</span>
        </el-form-item>
        <el-form-item label="优惠金额：">
          <el-input v-model="batchPayConfirmInfo.discountAmount" size="small" style="width:120px"
            placeholder="0.00" />
          <span style="margin-left:8px;">{{ $t('batchPayConfirm.yuan') }}</span>
        </el-form-item>
        <el-form-item label="实收金额：">
          <span>{{ actualReceivedAmount }} {{ $t('batchPayConfirm.yuan') }}</span>
        </el-form-item>
        <el-form-item label="账户抵扣金额：">
          <span>{{ deductionAmount }} {{ $t('batchPayConfirm.yuan') }}</span>
        </el-form-item>
        <el-form-item label="应缴金额：">
          <span>{{ payableAmount }} {{ $t('batchPayConfirm.yuan') }}</span>
        </el-form-item>
        <el-form-item label="欠费金额：">
          <span :style="{color: owedAmount > 0 ? '#E6A23C' : '#67C23A'}">
            {{ owedAmount }} {{ $t('batchPayConfirm.yuan') }}
          </span>
        </el-form-item>
        <el-form-item :label="$t('batchPayConfirm.paymentMethod')">
          <el-select v-model="batchPayConfirmInfo.primeRate" style="width:100%"
            :placeholder="$t('batchPayConfirm.selectPaymentMethod')">
            <el-option v-for="item in filteredPrimeRates" :key="item.statusCd" :label="item.name"
              :value="item.statusCd"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="票据类型">
          <el-radio-group v-model="batchPayConfirmInfo.receiptType">
            <el-radio label="machine">机打收据</el-radio>
            <el-radio label="hand">手写收据</el-radio>
            <el-radio label="invoice">发票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="batchPayConfirmInfo.receiptType !== 'machine'"
          :label="batchPayConfirmInfo.receiptType === 'invoice' ? '发票代码' : '手写收据编号'">
          <el-input v-model="batchPayConfirmInfo.receiptCode"
            :placeholder="batchPayConfirmInfo.receiptType === 'invoice' ? '请输入发票代码（整批共用）' : '请输入手写收据编号（整批共用）'" clearable />
        </el-form-item>
        <el-form-item label="缴费日期">
          <el-date-picker v-model="batchPayConfirmInfo.payTime" type="date" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="不选则默认为今天" style="width:100%" :picker-options="payDatePickerOptions" />
        </el-form-item>
        <el-form-item v-if="batchPayConfirmInfo.payType === 'qrCode'">
          <el-input v-model="batchPayConfirmInfo.authCode" :placeholder="$t('batchPayConfirm.scanCodeTip')"
            @keyup.enter.native="_qrCodePayFee"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('common.close') }}</el-button>
        <el-button type="primary" @click="_doPayFee" v-if="batchPayConfirmInfo.payType === 'common'">{{
          $t('batchPayConfirm.confirmPay') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('batchPayConfirm.payResult')" :visible.sync="resultVisible" width="500px">
      <div class="result-content">
        <p>{{ $t('batchPayConfirm.paySuccess') }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="_back">{{ $t('common.back') }}</el-button>
        <el-button type="primary" @click="_printAndBack('ON')">{{ $t('batchPayConfirm.mergePrint') }}</el-button>
        <el-button type="primary" @click="_printAndBack('OFF')">{{ $t('batchPayConfirm.printReceipt') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCommunityId, getDict } from '@/api/community/communityApi'
import { payBatchFee, qrCodePayment, checkPayFinish, listFeePrintPage } from '@/api/fee/batchPayFeeOrderApi'

export default {
  name: 'BatchPayConfirm',
  data() {
    return {
      visible: false,
      resultVisible: false,
      batchPayConfirmInfo: {
        payType: '',
        fees: [],
        primeRate: '',
        primeRates: [],
        payerObjName: '',
        orderId: '',
        paymentPoolId: '',
        authCode: '',
        receiptCode: '',
        feePrices: '',
        detailIds: '',
        printUrl: '/#/pages/property/printPayFee',
        accountAmount: '',
        acctId: '',
        acctType: '',
        discountAmount: '0.00',
        payTime: ''
      }
    }
  },
  computed: {
    // 缴费日期限制：只能选当前月份内的日期
    payDatePickerOptions() {
      const now = new Date()
      const curYear = now.getFullYear()
      const curMonth = now.getMonth() // 0-11
      return {
        disabledDate(time) {
          const t = time.getTime()
          const monthStart = new Date(curYear, curMonth, 1).getTime()
          const monthEnd = new Date(curYear, curMonth + 1, 0, 23, 59, 59).getTime()
          return t < monthStart || t > monthEnd
        }
      }
    },
    filteredPrimeRates() {
      let rates = []
      if (this.batchPayConfirmInfo.payType === 'qrCode') {
        rates = this.batchPayConfirmInfo.primeRates.filter(
          item => item.statusCd === '3' || item.statusCd === '4'
        )
      } else {
        rates = this.batchPayConfirmInfo.primeRates.filter(
          item => item.statusCd !== '5' && item.statusCd !== '6' && item.statusCd !== '8'
        )
      }
      // 当存在账户抵扣金额时，动态添加"账户抵扣"支付方式
      const accountAmount = parseFloat(this.batchPayConfirmInfo.accountAmount || 0)
      if (accountAmount > 0) {
        rates = [...rates]
      }
      return rates
    },
    // 应收金额 = 费用原始应收合计
    receivableAmount() {
      const fees = this.batchPayConfirmInfo.fees || []
      const total = fees.reduce((sum, fee) => {
        return sum + parseFloat(fee.receivableAmount || fee.feeTotalPrice || 0)
      }, 0)
      return total.toFixed(2)
    },
    // 实收金额 = 用户输入的实收合计
    actualReceivedAmount() {
      const fees = this.batchPayConfirmInfo.fees || []
      const total = fees.reduce((sum, fee) => {
        return sum + parseFloat(fee.receivedAmount || fee.amount || 0)
      }, 0)
      return total.toFixed(2)
    },
    // 优惠金额 = 用户输入（不再自动算 应收-实收）
    discountAmount() {
      const v = parseFloat(this.batchPayConfirmInfo.discountAmount || 0)
      return isNaN(v) ? '0.00' : v.toFixed(2)
    },
    // 应缴金额 = 实收 + 账户抵扣 + 优惠（用户实际付款）
    payableAmount() {
      const r = parseFloat(this.actualReceivedAmount)
      const d = parseFloat(this.deductionAmount)
      const p = parseFloat(this.discountAmount)
      return (r + d + p).toFixed(2)
    },
    // 欠费金额 = 应收 - 应缴（>0 表示还欠多少；<=0 表示已缴清）
    owedAmount() {
      const r = parseFloat(this.receivableAmount)
      const p = parseFloat(this.payableAmount)
      return Math.max(0, r - p).toFixed(2)
    },
    // 实际抵扣金额 = min(可抵扣费用合计, 账户金额)，仅同类型费用可抵扣
    deductionAmount() {
      const fees = this.batchPayConfirmInfo.fees || []
      const acctType = this.batchPayConfirmInfo.acctType || '2003'
      const accountAmount = parseFloat(this.batchPayConfirmInfo.accountAmount || 0)
      if (accountAmount <= 0) return '0.00'

      // 计算可被当前账户抵扣的费用总额
      let deductibleTotal = 0
      fees.forEach(fee => {
        const amount = parseFloat(fee.receivedAmount || fee.amount || 0)
        if (this._isFeeMatchAcctType(acctType, fee.feeTypeCd)) {
          deductibleTotal += amount
        }
      })
      if (deductibleTotal <= 0) return '0.00'
      return Math.min(deductibleTotal, accountAmount).toFixed(2)
    }
  },
  created() {
    this._initDictData()
    this._listFeePrintPages()
  },
  methods: {
    async _initDictData() {
      try {
        const data = await getDict('pay_fee_detail', 'prime_rate')
        this.batchPayConfirmInfo.primeRates = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },

    async _listFeePrintPages() {
      try {
        const params = {
          page: 1,
          row: 1,
          state: 'T',
          communityId: getCommunityId()
        }
        const res = await listFeePrintPage(params)
        if (res.code === 0 && res.data && res.data.length > 0) {
          this.batchPayConfirmInfo.printUrl = res.data[0].url
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },

    open(params) {
      this.batchPayConfirmInfo = {
        ...this.batchPayConfirmInfo,
        receiptCode: '',
        receiptType: 'machine',
        payTime: '',
        discountAmount: '0.00',
        ...params
      }
      this.visible = true

      if (params.payType === 'qrCode') {
        this.$nextTick(() => {
          document.getElementById("authCode").focus()
        })
      }
    },

    handleClose() {
      this.visible = false
    },

    async _doPayFee() {
      if (!this.batchPayConfirmInfo.primeRate) {
        this.$message.warning(this.$t('batchPayConfirm.selectPaymentMethodTip'))
        return
      }
      const rt = this.batchPayConfirmInfo.receiptType
      if ((rt === 'hand' || rt === 'invoice') && !(this.batchPayConfirmInfo.receiptCode && this.batchPayConfirmInfo.receiptCode.trim())) {
        this.$message.warning(rt === 'invoice' ? '请输入发票代码' : '请输入手写收据编号')
        return
      }

      const fees = this.batchPayConfirmInfo.fees.map(fee => ({
        ...fee,
        primeRate: this.batchPayConfirmInfo.primeRate
      }))

      try {
        const data = {
          communityId: getCommunityId(),
          fees,
          acctId: this.batchPayConfirmInfo.acctId,
          accountAmount: this.batchPayConfirmInfo.accountAmount,
          discountAmount: this.batchPayConfirmInfo.discountAmount || '0',
          receiptCode: this.batchPayConfirmInfo.receiptCode || '',
          receiptType: this.batchPayConfirmInfo.receiptType || 'machine',
          payTime: this.batchPayConfirmInfo.payTime || ''
        }

        const res = await payBatchFee(data)
        if (res.code === 0) {
          this._doDealPayResult(res)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.handleClose()
        this.$message.error('缴费失败')
      }
    },

    async _qrCodePayFee() {
      if (!this.batchPayConfirmInfo.primeRate) {
        this.$message.warning(this.$t('batchPayConfirm.selectPaymentMethodTip'))
        return
      }

      const fees = this.batchPayConfirmInfo.fees.map(fee => ({
        ...fee,
        primeRate: this.batchPayConfirmInfo.primeRate
      }))

      try {
        const data = {
          communityId: getCommunityId(),
          fees,
          acctId: this.batchPayConfirmInfo.acctId,
          accountAmount: this.batchPayConfirmInfo.accountAmount,
          discountAmount: this.batchPayConfirmInfo.discountAmount || '0',
          authCode: this.batchPayConfirmInfo.authCode,
          receivedAmount: this.batchPayConfirmInfo.feePrices,
          payerObjName: this.batchPayConfirmInfo.payerObjName,
          subServiceCode: 'fee.payBatchFee',
          payTime: this.batchPayConfirmInfo.payTime || ''
        }

        const res = await qrCodePayment(data)
        if (res.code === 404) {
          this.$message.warning(res.msg)
          if (res.data && res.data.orderId) {
            this.batchPayConfirmInfo.orderId = res.data.orderId
            this.batchPayConfirmInfo.paymentPoolId = res.data.paymentPoolId
            setTimeout(() => this._qrCodeCheckPayFinish(), 5000)
          }
        } else if (res.code === 0) {
          this._doDealPayResult(res)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error('扫码支付失败')
      }
    },

    async _qrCodeCheckPayFinish() {
      const fees = this.batchPayConfirmInfo.fees.map(fee => ({
        ...fee,
        primeRate: this.batchPayConfirmInfo.primeRate
      }))

      try {
        const data = {
          communityId: getCommunityId(),
          fees,
          acctId: this.batchPayConfirmInfo.acctId,
          accountAmount: this.batchPayConfirmInfo.accountAmount,
          authCode: this.batchPayConfirmInfo.authCode,
          receivedAmount: this.batchPayConfirmInfo.feePrices,
          subServiceCode: 'fee.payBatchFee',
          orderId: this.batchPayConfirmInfo.orderId,
          paymentPoolId: this.batchPayConfirmInfo.paymentPoolId,
          payTime: this.batchPayConfirmInfo.payTime || ''
        }

        const res = await checkPayFinish(data)
        if (res.code === 404) {
          this.$message.warning(res.msg)
        } else if (res.code === 41) {
          setTimeout(() => this._qrCodeCheckPayFinish(), 5000)
        } else {
          this._doDealPayResult(res)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error('支付状态查询失败')
      }
    },

    _doDealPayResult(res) {
      this.handleClose()
      const detailIds = res.data.details.join(',')
      this.batchPayConfirmInfo.detailIds = detailIds
      this.$emit('pay-success')

      setTimeout(() => {
        this.resultVisible = true
      }, 2000)
    },

    _printAndBack(merge) {
      this.resultVisible = false
      window.open(`${this.batchPayConfirmInfo.printUrl}?detailIds=${this.batchPayConfirmInfo.detailIds}&merge=${merge}`)
    },

    _back() {
      this.resultVisible = false
      this._refreshParent()
    },
    _refreshParent() {
      this.$emit('pay-success')
    },

    _isFeeMatchAcctType(acctType, feeTypeCd) {
      if (acctType === '2003') return true
      if (acctType === '2004') return feeTypeCd === '888800010001'
      if (acctType === '2005') return ['888800010015', '888800010016', '888800010009'].includes(feeTypeCd)
      if (acctType === '2006') return feeTypeCd === '888800010017'
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.result-content {
  text-align: center;
  font-size: 16px;
  padding: 20px;
}
</style>